import { type FC, memo } from "react";
import sprite from "../../../../assets/sprite.svg";
import { type IconProps } from "./types";
import styles from "./Icon.module.scss";

const Icon: FC<IconProps> = memo(
  ({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    title,
    ...props
  }) => {
    return (
      <svg
        width={size}
        height={size}
        fill={color}
        className={`${styles.icon} ${className}`}
        role={title ? "img" : "presentation"}
        aria-label={title}
        aria-hidden={!title}
        {...props}
      >
        <use xlinkHref={`${sprite}#${name}`} />
        {title && <title>{title}</title>}
      </svg>
    );
  },
);
Icon.displayName = "Icon";
export default Icon;
